import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  watchSubcategory, unwatchSubcategory, watchCategory, unwatchCategory, watchSubcategoryOnsite,
  unwatchSubcategoryOnsite, watchCategoryOnsite, unwatchCategoryOnsite
} from 'common/ducks/user';
import {
  watchSubcategory as adminWatchSubcat, unwatchSubcategory as adminUnwatchSubcat,
  watchCategory as adminWatchCat, unwatchCategory as adminUnwatchCat,
  watchSubcategoryOnsite as adminWatchSubcatOnsite,
  unwatchSubcategoryOnsite as adminUnwatchSubcatOnsite, watchCategoryOnsite as adminWatchCatOnsite,
  unwatchCategoryOnsite as adminUnwatchCatOnsite
} from 'admin/ducks/people';
import { getWatchableCategories } from 'common/ducks/categories';
import SubcatWatchlist from 'account/components/sub_category_watchlist';

const mapStateToProps = ({ user, categories, admin }, { atAdmin }) => {
  return {
    user: atAdmin? admin.people.currentUser : user.profile_data,
    categories: getWatchableCategories(categories.data)
  };
}

const mapDispatchToProps = (dispatch, { atAdmin }) => {
  return bindActionCreators({
    watchSubcategory: atAdmin? adminWatchSubcat : watchSubcategory,
    unwatchSubcategory: atAdmin? adminUnwatchSubcat : unwatchSubcategory,
    watchCategory: atAdmin? adminWatchCat : watchCategory,
    unwatchCategory: atAdmin? adminUnwatchCat : unwatchCategory,
    watchSubcategoryOnsite: atAdmin? adminWatchSubcatOnsite : watchSubcategoryOnsite,
    unwatchSubcategoryOnsite: atAdmin? adminUnwatchSubcatOnsite : unwatchSubcategoryOnsite,
    watchCategoryOnsite: atAdmin? adminWatchCatOnsite : watchCategoryOnsite,
    unwatchCategoryOnsite: atAdmin? adminUnwatchCatOnsite : unwatchCategoryOnsite
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SubcatWatchlist);



// WEBPACK FOOTER //
// ./account/containers/sub_category_watchlist.js